export const ERROR_LOADING_MAPPING = 'Unable to load Linear TV Mapping.';
